<template>
  <BootstrapModal v-model="modalShow" :small="true" :title="$t('labels.reminder')" :backdrop="false" :showClose="true">
    <p class="color-333">{{ $t('trade.cancel.confirm') }}</p>
    <div class="text-right pt-5">
      <v-btn
        class="no-shadow"
        :loading="rejectPartnerInvCommitting"
        color="#1E49AC"
        @click="rejectPartnerInvitation"
        style="color:white; float:right;"
        >{{ $t('actions.confirm') }}</v-btn
      >
    </div>
  </BootstrapModal>
</template>
<script>
import BootstrapModal from '@/components/Modal/BootstrapModal/BootstrapModal';
import { partnerApi } from '@/api/partner/partnerApi';

export default {
  name: 'RejectPartnerInvitation',
  components: { BootstrapModal },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rejectPartnerInvCommitting: false,
      modalShow: false
    };
  },
  methods: {
    rejectPartnerInvitation() {
      if (this.rejectPartnerInvCommitting) {
        return;
      }
      this.rejectPartnerInvCommitting = true;
      partnerApi
        .rejectPartnerInvitation()
        .then(() => {
          this.successNotify(this.$t('success.rejectPartnerInvitation'));
          this.rejectPartnerInvCommitting = false;
          this.$emit('update:show', false);
          this.$emit('refreshAffAndParInfo');
        })
        .catch(() => {});
    }
  },
  watch: {
    show: function(val) {
      this.modalShow = val;
    },
    modalShow: function(val) {
      this.$emit('update:show', val);
    }
  }
};
</script>

<style scoped></style>
